import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=13366af4&scoped=true&"
import script from "./Candle.vue?vue&type=script&lang=ts&"
export * from "./Candle.vue?vue&type=script&lang=ts&"
import style0 from "./Candle.vue?vue&type=style&index=0&id=13366af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13366af4",
  null
  
)

export default component.exports